<template>
  <div>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="700"
          v-model="dialogus"
        >

          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :color="colorinfos.buttonCartColor"

              fixed
              top
              right
              fab
            >
              <v-icon :color="colorinfos.textCartColor">mdi-cart</v-icon>
              <span class="nb-article" :style="{color:colorinfos.textCartColor}">{{ nbarticle }}</span>
            </v-btn>
          </template>
          <template>
            <v-card :color="colorinfos.buttonCartColor" v-if="stagecardview == 1">
              <v-toolbar
                :color="colorinfos.buttonCartColor"
                class="text-center"
                style=" border:0; box-shadow:none"
                dark
              >
                <v-spacer>
                  <v-toolbar-title
                    >Mon Panier ({{ listcart.length }} produits)
                  </v-toolbar-title>
                </v-spacer>
              </v-toolbar>

              <v-container fluid>
                <v-layout
                  v-bind:key="elemkey"
                  row
                  v-for="(elemcart, elemkey) in listcart"
                >
                  <v-flex xs2 order-md1 order-xs1>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text style="display:none" >{{ elemcart.quantity }}x</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4 order-md2 order-xs2>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text
                        >{{ elemcart.article.title }}&nbsp;<strong>x{{
                          elemcart.quantity
                        }}</strong></v-card-text
                      >
                    </v-card>
                  </v-flex>
                  <v-flex xs4 order-md3 order-xs3>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text>{{ elemcart.total_price }}F</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2 order-md4 order-xs4>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text @click.prevent="RemoveOnCart(elemcart,elemkey)"
                        ><v-icon small color="white ">
                          mdi-delete-outline
                        </v-icon></v-card-text
                      >
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-divider class="mx-4"></v-divider>
                <v-layout row>
                  <v-flex xs2 order-md1 order-xs1>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text></v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4 order-md2 order-xs2>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text>Total</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4 order-md3 order-xs3>
                    <v-card dark tile flat :color="colorinfos.buttonCartColor">
                      <v-card-text>{{ getSum() }}F</v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-card-actions class="justify-center card-action-bottom">
                <v-container>
                  <v-row>
                    <v-col xs="12" md="6">
                      <v-btn
                        color="white"
                        class="btn-cart"
                        @click="dialogus = false"
                        ><v-icon>mdi-undo</v-icon></v-btn
                      >
                    </v-col>
                    <v-col xs="12" md="6">
                      <v-btn
                        xs4
                        :disabled="disabledfinalisation"
                        color="white"
                        :style="{ color: colorinfos.buttonCartColor }"
                        class="btn-cart"
                        @click.prevent="showkyc()"
                        >finaliser ma commande</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
            <v-card
              v-show="stagecardview == 2"
              min-width="100%"
              :color="colorinfos.buttonCartColor"
            >
              <form-kyc
                @previous="gobackward" :colorinfos="colorinfos"
                ref="formkyctag" :gotoniveau="default_niveau"
                :getbackupkycdata="backupkycform"
                @datareportedFromChild="datasReceivedFromKyc"
              ></form-kyc>
            </v-card>

            <v-card
              class="v-card-ending"
              v-if="stagecardview == 3"
              min-width="100%"
              :color="colorinfos.buttonCartColor"
              style="paddin:30px"
            >
              <v-card-title class="text-center title-map">
                Faites vous livrer efficacement avec la géolocalisation!
              </v-card-title>
              <v-spacer></v-spacer>
              <v-card-subtitle class="text-center subtitle-map">
               Ou souhaitez-vous être livré ?
              </v-card-subtitle>




              <v-spacer></v-spacer>

              <div class="indication">
               <find-my-loc
              :showpreviousbutton=true
              @previous="gobackwardstage"
              @getdataloc="datafromlocation"
            ></find-my-loc>
              </div>

              <v-card-actions class="yangoz">
                <v-row>
                  <v-col xs="12" md="6">
                    <v-btn
                      color="white" :style="{color:colorinfos.buttonCartColor}"
                      class="btn-dd"
                      @click="dialogus = false"
                      >Annuler</v-btn
                    >
                  </v-col>
                  <v-col xs="12" md="6" style="display:none">
                    <v-btn
                      xs4
                      :disabled="disabledfinalisation"
                      color="white"
                      class="btn-dd"
                      @click.prevent="
                        dialogus = false;
                        validationCommand();
                      "
                      >Valider</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Kyc from "./kyc.vue";
import FindMyLoc from "./findmyloc.vue";
export default {
  components: {
    "form-kyc": Kyc,
    'find-my-loc': FindMyLoc
  },
  props: {
    nbarticle: Number,
    listcart: Array,
    colorinfos: Object
  },
  watch: {
    yaya: function() {
      /*let Oldthis = this;
       let somsome= 0;
        _.forEach(this.listcart, function(value, key) {
            somsome+= value.total_price;
        });
         Oldthis.sommeTotale = somsome;
    }*/
    }
  },
  data() {
    return {
      nb_items: 0,
      dialogus: false,
      default_niveau: 1,
      yaya: {},
      sommeTotale: 0,
      disabledfinalisation: true,
      stagecardview: 1,
      backupkycform: {
        tel: "",
        complete_name: "",
        remember_me: ""
      },
      datasreported: {},
      positionclient: {
        lat: 10,
        lng: 10
      },
      colorgreen: "#00a65ad4",
      colorred: "#EF323D",

      item_depos: [],
      loading: false,
      zonedepos: []
    };
  },
  computed: {
    state_zonedepos: function() {
      console.log("**COMPUTED** changement state_zonedepos");
      zone_done = [];
      let Oldthis = this;

      _.forEach(Oldthis.zonedepos, function(zone, kr) {
        $zone = zone.properties.Name;
        zone_done.push($zone);
      });
      if (!_.isEmpty(zone_done)) {
        return zone_done;
      }
    }
  },
  watch: {
    nbarticle: function(val) {
      if (val > 0) {
        this.disabledfinalisation = false;
      } else {
        this.disabledfinalisation = true;
      }
    }
  },
  mounted() {
    console.log("nbarticle done zer", this.nbarticle);
    console.log("<--------------------->");
    console.log("listcart", this.listcart);

    this.nb_items = parseInt(this.nbarticle);
  },
  methods: {
    gobackwardstage(){

        this.default_niveau = 3
        if(this.default_niveau == 3)
        {
          console.log('default_niveau',this.default_niveau)
           this.stagecardview = 2
        }
        if(this.stagecardview== 2){
            console.log('gobackwardstarge niveau--->',this.$refs)
            this.$refs.formkyctag.niveau = 3;
        }
        //this.$refs.formkyctag.niveau=3
        console.log('we are going backward',this.stagecardview)

    },
    datafromlocation(dataloc){
        console.log('this iss data from location',dataloc);
        this.datasreported.findmyloc = dataloc
        this.datasreported.gotcoordinate = true;
        this.dialogus = false;
        if(this.datasreported.remember_me){
           localStorage.setItem('complement_adress',dataloc.complement_adress)
           localStorage.setItem('selectzone_livraison',dataloc.selectzone_livraison)
        }
        this.validationCommand();
    },
    getSum() {
      let somsome = 0;
      _.forEach(this.listcart, function(value, key) {
        somsome += parseInt(value.total_price);
      });
      return somsome;
    },
    updateCoordinates(location) {
      //console.log('updateCoordinates',location.latLng)
      this.positionclient = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
      this.datasreported.current_position = this.positionclient;
    },
    validationCommand() {
      //this.dialogus = false
      this.$emit("datasFromCartbox", this.datasreported);
    },
    RemoveOnCart(article,key) {
      console.log("RemoveOnCart slicing=>", key);
      this.listcart.splice(key,1);
      this.$emit("articleToRemove", {
        id: article.id
      });
    },
    showkyc() {
      this.stagecardview = 2;
    },
    hidekyc() {
      this.stagecardview = 1;
    },
    gobackward(value) {
      console.log("the gobackward ----1", value);
      if (value.niveau == 0) {
        this.hidekyc();
        this.backupkycform.tel = value.kyc_datas.tel;
        this.backupkycform.complete_name = value.kyc_datas.complete_name;
        this.backupkycform.remember_me = value.kyc_datas.remember_me;
      }
    },
    datasReceivedFromKyc(datasreported) {
      console.log(
        "voici les informations recus par l'enfant ==>",
        datasreported
      );
      this.datasreported = datasreported;
      //this.getCurrentPosition();
      this.gotoFindMyLoc();
    },
    gotoFindMyLoc(){
      this.stagecardview = 3;
    },
    getCurrentPosition() {
      let Oldthis = this;
      this.$getLocation({
        enableHighAccuracy: true
      })
        .then(coordinates => {
          console.log("trouver la position dat ");

          this.positionclient.lat = coordinates.lat;
          this.positionclient.lng = coordinates.lng;

          Oldthis.datasreported.gotcoordinate = true;
          Oldthis.datasreported.current_position = coordinates;

          console.log(coordinates, "<=== vous avez bien été géolocalisé");
        })
        .catch(error => {
          alert(
            "Nous avons besoin de vos coordonnées GPS pour faciliter la livraison. Merci de cliquer sur autoriser"
          );
        });
    }
  }
};
</script>

<style>
.v-dialog {
  position: absolute;
  margin: 0;
  top: 0% !important;
}
.nb-article {
  font-weight: bold;
  font-size: 15px;
}

.v-card__text {
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
}
.v-divider {
  background-color: #ffffff !important;
  color: #ffffff !important;
}

.btn-cart {
  border: 0;
  padding-left: 5% !important;
  padding-right: 5% !important;
  /*color: #ef323d !important;*/
  font-weight: bold !important;
  font-size: 13px !important;
}

.btn-dd {
  border: 0;
 /* color: #ef323d !important;*/
  font-weight: normal !important;
  font-size: 13px !important;
  width: 100%;
  margin-bottom: 25px;
}
.card-action-bottom {
  padding-bottom: 25px !important;
}

.v-application .error--text {
  color: #ffffff !important;
  caret-color: #ffffff !important;
}
.theme--light.v-label {
}
.checkbox-element {
}

.titleme {
  color: #ffffff !important;
  text-align: center !important;
  widows: 100%;
  margin-left: 30%;
  transform: translateX(-20%);
  margin-bottom: 10%;
}
.subtitleojay {
  font-size: 18px !important;
  color: #ffffff !important;
}
.title-map,
.subtitle-map {
  color: #ffffff !important;
  padding-top: 12px;
}

.title-map {
  font-weight: bold !important;
}
.padingtone {
  margin: 0px 5px 0px 5px;
}
.indication {
  margin: 0px 5px 0px 5px;
  color: #ffffff;
}
.indication span {
  font-size: 14px;
  font-weight: bold;
}

.v-card-ending {
  padding-bottom: 100px !important;
}
.yangoz {
  padding-bottom: 100px !important;
}

.linktoac {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.linktoac > a {
  margin: 20px;
}
.linktoac > a{
  color: #fafafa ;
  font-weight: bold;
  padding-left: 15px;

}




.activaa {
  color: rgba(0, 0, 0, 0.6) !important;
  background: #fafafa !important;
  caret-color: #a81515 !important;
  padding-left: 15px;
}
.activaa:hover {
  color: rgba(0, 0, 0, 0.6) !important;
}
.subtitle-map{
    cursor: pointer;
    font-size: 15px;
    color:aliceblue;
    font-weight: bold;
}

.color-check{
   color: white ;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/cartbox.vue